import { render, staticRenderFns } from "./Finance-expense-payment.vue?vue&type=template&id=51b472ce&"
import script from "./Finance-expense-payment.vue?vue&type=script&lang=js&"
export * from "./Finance-expense-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports